import React from "react";
import DropDown from "../DropDown/DropDown";
import SearchBar from "../SearchBar/SearchBar";
import * as styles from "./PreHeader.module.scss";

const PreHeader = ({ color = "black", colorLupa, paises }) => {
  const colorStyles = {
    white: styles.color_white,
    black: styles.color_black,
  };

  const colorBackgrou = {
    white: "white",
    black: "black",
  };

  const colorClass = colorStyles[color];
  const colorClass2 = colorBackgrou[color];

  return (
    <div className={`${styles.searchBar} ${colorClass} section`}>
      <div className={`${styles.centerSearchBar} container`}>
        <DropDown name={"Pais"} options={paises} color={colorClass2} />
        <SearchBar color={colorLupa} />
      </div>
    </div>
  );
};

export default PreHeader;
